/**
 * ABUI用のカスタマイズ等の設定ファイル
 */

/**
 * ワード検索 テキストボックスへのfocusクラス追加/削除 制御(UI調整用)
 * @see ABUI_doc__Component_TextField.html
 */
if($('.input-group').length) {
  $('.input-group').on('focus', '.form-control', function () {
    $(this).closest('.input-group, .form-group').addClass('focus');
  }).on('blur', '.form-control', function () {
    $(this).closest('.input-group, .form-group').removeClass('focus');
  });

  /**
   * .input-group-btnを後ろに持つ.form-controlのpaddingを制御するためのclass付与
   */
  if($('.input-group-btn').length) {
    $('.input-group .input-group-btn').prev('.form-control').addClass('has-btn-after');
  }
}

/**
 * フォーカス時ペンシルアイコンをprimaryカラーにする
 * @see      サジェスト付きフィールド
 * @see      ABUI_doc__Component_TextField.html
 * @external https://github.com/twitter/typeahead.js/blob/master/doc/jquery_typeahead.md
 */
if ($('.form-group-typeahead').length) {
  $(document).find('input.input-typeahead').on('typeahead:active', function(ev, suggestion) {
    $(this).closest('.input-with-icon').children('.input-icon-typeahead.icon-abui-pencil').css('color','#029df4');
  }).on('blur', function() {
    $(this).closest('.input-with-icon').children('.input-icon-typeahead.icon-abui-pencil').css('color','');
  });
}

/**
 * アップロード
 * @see      ABUI_doc__Pattern_Upload.html
 * @external DropZone https://www.dropzonejs.com/
 */
if ($('.dropzone').length) {
  Dropzone.options.fileupload = {
    paramName: "file", // The name that will be used to transfer the file
    maxFilesize: 5, // MB
    addRemoveLinks: 'true',
    dictDefaultMessage: '<span class="icon icon-abui-file"></span>ファイルをここにドラッグアンドドロップ<small>またはクリックで場所を指定</small>',
    dictFallbackMessage: "ブラウザーがドラッグアンドドロップでのアップロードに対応していません",
    dictFileTooBig: "サイズが大きすぎます（{{filesize}}MB）。上限は{{maxFilesize}}MBです",
    dictInvalidFileType: "この形式のファイルはアップロードできません。jpgおよびpng形式のファイルを指定してください",
    dictResponseError: "予期しないエラーが発生しました。管理者に問い合わせてください。エラーコード： {{statusCode}}",
    dictCancelUpload: "アップロードを中止",
    dictCancelUploadConfirmation: "アップロードを中止してよろしいですか",
    dictRemoveFile: "",
    dictMaxFilesExceeded: "アップロード可能なファイル数の上限に達しました。"
  };
}

/**
 * フットブロック
 * @see ナビゲーションバー
 * @see ABUI_doc__Pattern_NavigationBar_Footblock.html
 * @description フットブロック時、パディング（48px）自動付与
 */
if($('.navbar-footblock').length) {
  /**
   * ターゲットとなるクラス取得
   * @type {Object}
   */
  const getElemWrapper = document.getElementsByClassName('wrapper')[0];
  getElemWrapper.classList.add('with-navbar-fixed-bottom');
}

/**
 * bootstrapでmodalがスクロールできなくなる場合の対処
 * @see ABUI_doc__Component_Modal.html
 */
if($('.modal').length) {
  $(document).on('hidden.bs.modal', '.modal', function() {
    if($('.modal').is(':visible')) {
      $('body').addClass('modal-open');
    }
  });
}


/**
 * IE11, Edgeのみ
 */
window.addEventListener('DOMContentLoaded', function() {
  /**
   * ブラウザー判定
   * @type {String}
   */
  let userAgent = window.navigator.userAgent.toLowerCase();

  /**
   * ul要素を取得
   * @type {Object}
   */
  let tgtElem = document.getElementsByTagName('ul');

  /**
   * IE11、Edgeのみ"list-style"が効かないバグ 対策
   * @param {Number} userAgent.indexOf('trident/7.0') IE11
   * @param {Number} userAgent.indexOf('edge')        Edge
   */
  if(userAgent.indexOf('trident/7.0') > -1) {
    for (let i=0; i<tgtElem.length; i++) {
      tgtElem[i].style.listStyleType = 'none';
    }
  }
  // } else if(userAgent.indexOf('edge') > -1) {
    // for (let i=0; i<tgtElem.length; i++) {
    //   tgtElem[i].style.listStyleType = 'none';
    //   tgtElem[i].style.listStyleImage = 'url("data:0")';
    // }
  // }

  /**
   * IE11でincludesメソッドが利用できるようにするPolyfill
   */
  if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
      value: function(searchElement, fromIndex) {

        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        let o = Object(this);
        let len = o.length >>> 0;

        if (len === 0) {
          return false;
        }

        let n = fromIndex | 0;
        let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        while (k < len) {
          if (o[k] === searchElement) {
            return true;
          }
          k++;
        }
        return false;
      }
    });
  }
}, false);